import select2 from '../modules/select2';

export default () => {
    select2($('.form select'),
        {
            theme: 'visual-block',
            minimumResultsForSearch: Infinity
    });
};


// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/select2.js